// TODO: refactor this file
import { useTranslation } from "providers/i18n"
import { FeatureActionContainer } from "containers/FeatureActionContainer"
import _ from "lodash"

import {
  Card,
  styled,
  Box,
  Typography,
  Stack,
  Skeleton,
  useTheme,
  Avatar,
} from "@mui/material"
import { FeatureLabel } from "components/domains/features/FeatureLabel"
import { CustomIcon, ShopIcon } from "components/icons"

const ShortInfoWrapper = styled(Card)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  boxShadow: "none",
}))

const ShortInfoActionWrapper = styled(Stack)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  paddingTop: theme.spacing(1),
}))

const LoadingFeature = () => {
  return (
    <Box>
      <ShortInfoWrapper>
        <Skeleton variant="circular" width={80} height={80} />
        <Box>
          <Skeleton variant="text" width={180} />
          <Stack spacing={0.5} sx={{ mb: 1 }}>
            <Skeleton variant="text" width={80} />
            <Skeleton variant="text" width={80} />
          </Stack>
          <Skeleton variant="text" width={150} />
        </Box>
      </ShortInfoWrapper>
      <ShortInfoActionWrapper direction={"row"} spacing={2}>
        <Skeleton variant="text" width={70} height={40} />
        <Skeleton variant="text" width={70} height={40} />
      </ShortInfoActionWrapper>
    </Box>
  )
}

export const FeatureSummary = ({ DirectionButtonProps, ...props }) => {
  const { t } = useTranslation({ defaultValue: null })
  const theme = useTheme()
  const styleOverrides =
    theme.components[`FeatureSummary`]?.styleOverrides || {}
  const {
    root,
    container,
    infoSection,
    title,
    infoContainer,
    logoContainer,
    logoImage,
    locationText: locationTextStyle,
    operationTimeLabel,
    categoryText: categoryTextStyle,
    categoryIcon: categoryIconStyle,
  } = styleOverrides
  const {
    logo,
    category,
    categoryIcon,
    phone,
    level,
    name,
    hours,
    id,
    loading,
    onNavigate,
    venueName,
  } = props
  const categoryText = t(category)
  const levelText = level && t("Level Text", { level: t(level) })
  const nameText = t(name)
  const venueNameText = venueName && t(venueName)

  const locationText = _.compact([venueNameText, `${levelText}`]).join(" - ")

  if (loading) return <LoadingFeature />

  return (
    <Stack justifyContent="space-between" sx={root}>
      <Card sx={container}>
        <Box sx={logoContainer}>
          <Avatar src={logo} variant="logo" sx={logoImage}>
            {!logo &&
              (categoryIcon ? (
                <CustomIcon path={categoryIcon} sx={categoryIconStyle} />
              ) : (
                <ShopIcon />
              ))}
          </Avatar>
        </Box>
        <Stack direction="row" sx={infoContainer}>
          <Box sx={infoSection}>
            <Typography variant="title" component="h3" sx={title}>
              {nameText}
            </Typography>
            {locationText && (
              <FeatureLabel
                value={locationText || "-"}
                sx={locationTextStyle}
              />
            )}
            {categoryText && (
              <FeatureLabel
                value={categoryText || "-"}
                sx={categoryTextStyle}
              />
            )}
            {hours && (
              <FeatureLabel
                label="Open:"
                value={hours}
                sx={operationTimeLabel}
              />
            )}
          </Box>
        </Stack>
      </Card>
      <FeatureActionContainer
        destinationId={id}
        phone={phone}
        onNavigate={onNavigate}
        ShareProps={{ title: t(name) }}
        DirectionButtonProps={DirectionButtonProps}
      />
    </Stack>
  )
}
